(function () {
var $7c6e90ba02d329fa$exports = {};
(function($, root, undefined) {
    $(function() {
        'use strict';
        // DOM ready, take it away
        // Scroll to anchor
        $('a[href^="#"]').on('click', function(e) {
            var target = this.hash;
            if (!target) return;
            var $target = $(target);
            if (!$target.length) return;
            e.preventDefault();
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 400, 'swing');
        });
        //
        // criteria questions
        //
        let startButtons = $('#page-content .start-buttons button');
        startButtons.click(function() {
            // add active class to the button
            startButtons.not(this).removeClass('active');
            $(this).addClass('active');
            let questions = $(this).attr('rel');
            $('.questions').hide().removeClass('active');
            $('#' + questions).show().addClass('active');
        });
        let radioInputs = $('.answers input');
        // update progressbar
        function updateProgressBar(questionNumber) {
            let activeQuestionSet = $('.questions.active');
            let progressBar = activeQuestionSet.find('.progress');
            let bar = progressBar.find('.bar');
            let current = progressBar.find('.current');
            let total = progressBar.find('.total').data('total');
            // update percentage
            let percentage = 100 / (total - 1) * questionNumber;
            bar.css('width', percentage + '%');
            // update current number
            current.html(questionNumber);
        }
        // check if all questions are answered
        function allQuestionsAnswered() {
            let activeQuestionSet = $('.questions.active');
            let questions = activeQuestionSet.find('.question');
            let allAnswered = true;
            questions.each(function() {
                let answers = $(this).find('.answers');
                let inputs = answers.find('input');
                let answered = false;
                inputs.each(function() {
                    if ($(this).is(':checked')) answered = true;
                });
                if (answered == false) allAnswered = false;
            });
            return allAnswered;
        }
        // check answers
        function checkAnswers() {
            let activeQuestionSet = $('.questions.active');
            let answers = activeQuestionSet.find('.answers');
            let results = activeQuestionSet.find('.result');
            let showResult = '';
            let questionsAnswered = allQuestionsAnswered();
            // loop trhough answers
            answers.each(function() {
                // get value of selected radio input
                let answer = $(this).find("input[type='radio']:checked").val();
                // if yes
                if (answer == 'ja') showResult = 'ja';
                else if (answer == 'weet-ik-niet') showResult = 'weet-ik-niet';
                // breaks from loop if one answer is yes
                if (showResult == 'ja') return false;
            });
            // show result
            if (questionsAnswered == true) {
                results.hide();
                if (showResult == 'ja') activeQuestionSet.find('.result.ja').fadeIn();
                else if (showResult == 'weet-ik-niet') activeQuestionSet.find('.result.weet-ik-niet').fadeIn();
                else activeQuestionSet.find('.result.nee').fadeIn();
                $('html, body').animate({
                    scrollTop: $(activeQuestionSet).find('.results').offset().top - 96
                }, 2000);
            }
        }
        // on radio input change
        radioInputs.change(function() {
            let question = $(this).closest('.question');
            let nextQuestion = question.next('.question');
            let questionNumber = $(question).data('questionNumber');
            // update progressbar
            if (nextQuestion.hasClass('active')) ;
            else updateProgressBar(questionNumber);
            // show next question
            nextQuestion.fadeIn().css('display', 'flex').addClass('active');
            // check answers
            checkAnswers();
        });
        // enlarge number
        let numbers = $('.number');
        $(numbers).each(function(index, element) {
            let showNumber = gsap.timeline({
                paused: true
            });
            let numberText = $(this).find('.text');
            let numberTitle = $(this).find('.title');
            showNumber.to($(this), {
                width: '60%',
                top: '-50%',
                left: '20%',
                ease: Power3.easeOut,
                duration: .6
            });
            showNumber.to(numberTitle, {
                ease: Power3.easeOut,
                fontSize: '56px',
                duration: .2,
                delay: -0.6
            });
            showNumber.to(numberText, {
                ease: Power3.easeOut,
                width: '100%',
                duration: .1
            });
            showNumber.to(numberText, {
                ease: Power3.easeOut,
                height: 'auto',
                autoAlpha: 1,
                duration: .2
            });
            element.animation = showNumber;
        });
        $(numbers).click(function() {
            if ($(this).hasClass('active')) {
                let number = $(this);
                this.animation.reverse().timeScale(-2);
                $(numbers).not(this).removeClass('inactive');
                setTimeout(function() {
                    number.removeClass('active');
                    number.css('transition', '.2s ease');
                    number.css('z-index', '1');
                }, 400);
            } else {
                $(this).addClass('active').css('transition', 'none');
                $(this).css('z-index', '99');
                $(numbers).not(this).addClass('inactive');
                this.animation.play().timeScale(1);
            }
        });
        // print single questionnaire
        $(document).on('click', '.print-single-questions', function(e) {
            e.preventDefault();
            $('body').addClass('print-single');
            window.print();
        });
        $(window).on('afterprint', function() {
            $('body').removeClass('print-single');
        });
        // numbers mobile
        $('.open-modal').click(function() {
            let modal = $(this).attr('rel');
            $('.modal-container').hide();
            $('#' + modal).show().css('display', 'flex');
            $('.mobile-modal').fadeIn().css('display', 'flex');
        });
        $('.mobile-modal').click(function() {
            $(this).fadeOut();
        });
    });
})(jQuery, $7c6e90ba02d329fa$exports);

})();
//# sourceMappingURL=index.js.map
